import { render, staticRenderFns } from "./PatientQueue.vue?vue&type=template&id=6d3850ef&scoped=true"
import script from "./PatientQueue.vue?vue&type=script&lang=js"
export * from "./PatientQueue.vue?vue&type=script&lang=js"
import style0 from "./PatientQueue.vue?vue&type=style&index=0&id=6d3850ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3850ef",
  null
  
)

export default component.exports